import React, { useState } from 'react'
import { Accordion } from 'semantic-ui-react'
// Local
import { CONDITION } from '../../../constant'
import PatientSnapshotCondition from './patientSnapshotCondition'
import ClinicalAdminConditionHccHeaderTitle from '../clinicalAdmin/clinicalAdminConditionHccHeaderTitle'
import { ConditionType } from '../../patient/patient'
import { EncounterConditionDisplay } from '../../authenticated/types'

/**
 * Provides a component that displays conditions grouped under an HCC for the
 * Patient Snapshot view of conditions. The Patient Snapshot view of conditions
 * s very similar to the Clinical Admin view of conditions and may use some of
 * those components
 *
 * @param mode View mode. Options: "smart", null. Default: null
 * @param hccCode HCC code
 * @param hccDescription HCC description
 * @param activeConditionId currently set active conditionId from 
 * the last call of "this.props.onConditionAction(ACTIVATE || DEACTIVATE, domKey)"
 *                          this value is set by: `${this.props.conditionGroupTitle}-${this.props.hccCode}`
 * @param conditionGroupTitle the conditionStatus group, values: KNOWN, POTENTIAL, or ACTIVITY
 * @param conditions List of conditions to display in the group
 * @param onConditionAction Callback for condition action.
 *        Arguments: action, condition
 */

type Props = {
  activeConditionId: string | null
  conditionGroupTitle: ConditionType
  conditions: EncounterConditionDisplay[]
  hccCode: string | null
  hccDescription: string | null
  onConditionAction: (
    action: keyof typeof CONDITION.ACTION,
    condition: EncounterConditionDisplay | string
  ) => void
}

function PatientSnapshotConditionHccGroup(
  props: Props
): JSX.Element | null {
  const {
    activeConditionId,
    conditionGroupTitle,
    conditions,
    hccCode,
    hccDescription,
    onConditionAction
  } = props

  const domKey = `${conditionGroupTitle}-${hccCode}`

  const [
    isActiveState,
    setIsActiveState
  ] = useState<boolean>(activeConditionId === domKey)

  const onClickTitle = (): void => {
    const { ACTIVATE } = CONDITION.ACTION
    const { DEACTIVATE } = CONDITION.ACTION
    const { READ } = CONDITION.ACTION
    if (isActiveState) {
      // deactivate group
      setIsActiveState(false)
      onConditionAction(
        DEACTIVATE,
        domKey
      )
    } else {
      // activate group
      setIsActiveState(true)
      onConditionAction(
        ACTIVATE,
        domKey
      )
      conditions.forEach(c => {
        onConditionAction(
          READ,
          c
        )
      })
    }
  }

  const renderConditions = (): JSX.Element => (
    <div>
      <Accordion.Title
        key={ domKey }
        active={ isActiveState }
        onClick={ onClickTitle }
      >
        <div>
          <ClinicalAdminConditionHccHeaderTitle
            conditions={ conditions }
            active={ isActiveState }
            // mode={ mode }
            hccCode={ hccCode || '' }
            hccDescription={ hccDescription || '' }
            // onConditionAction={ onConditionAction }
          />
        </div>
      </Accordion.Title>
      <Accordion.Content active={ isActiveState }>
        <Accordion fluid>
          {
            conditions.map((condition, displayIndex) => (
              <PatientSnapshotCondition
                key={ condition.id }
                hccChild={ true }
                condition={ condition }
                displayIndex={ displayIndex }
                onConditionAction={ onConditionAction }
              />
            ))
          }
        </Accordion>
      </Accordion.Content>
    </div>
  )

  return conditions && conditions.length > 0
    ? renderConditions()
    : null
}

export default PatientSnapshotConditionHccGroup
